module.exports = __webpack_public_path__ + "img/arrow_down.d943c845.svg";